const DEFAULT_TAWK_PROPERTY_ID = "6abd3117c696c83445ed8cb0";
const DEFAULT_TAWK_WIDGET_ID = "1k3pgfhkq";

/** Tawk.to live chat embed URL. Override via REACT_APP_TAWK_PROPERTY_ID + REACT_APP_TAWK_WIDGET_ID. */
export function getTawkEmbedSrc(): string {
  const propertyId = (
    process.env.REACT_APP_TAWK_PROPERTY_ID || DEFAULT_TAWK_PROPERTY_ID
  ).trim();
  const widgetId = (
    process.env.REACT_APP_TAWK_WIDGET_ID || DEFAULT_TAWK_WIDGET_ID
  ).trim();

  if (!propertyId || !widgetId) return "";
  return `https://embed.tawk.to/${propertyId}/${widgetId}`;
}
